import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=77c38db0&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=77c38db0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c38db0",
  null
  
)

export default component.exports